export interface WizardErrorBannerProps {
  message: string;
  customerServicePhone: string;
  onRetry: () => void;
}

export function WizardErrorBanner({
  message,
  customerServicePhone,
  onRetry,
}: WizardErrorBannerProps) {
  return (
    <div className="alert alert-danger" role="alert">
      <h5 className="alert-heading">Enrollment Failed</h5>
      <p className="mb-1">{message}</p>
      <p className="mb-3 small">
        If this problem continues, please contact customer service at{' '}
        <strong>{customerServicePhone}</strong>.
      </p>
      <button type="button" className="btn btn-sm btn-outline-danger" onClick={onRetry}>
        Try Again
      </button>
    </div>
  );
}
